import SupportResponseCollectionView    from 'scripts/defa/support/view-support-response-collection-view';
import SupportResponseFunctionalityView from 'scripts/defa/support/view-support-response-functionality-view';
import Snippet                          from 'scripts/poppet/snippet';
import template                         from 'templates/supportResponseSnippet.jst.html';

/**
 * defa.views.SupportResponseSnippet
 * A Nesting tree-snippet for SupportResponses.
 * @version 1.2.1
 */

const selectors = {
	buttonOpen         : '[data-click=snippet-open]',
	buttonExpand       : '[data-toggle=expand-spoiler]',
	spoilerExpand      : '[data-container=expand-spoiler]',
	regionFunctionality: '[data-region=snippet-functionality]',
	regionContainer    : '[data-region=snippet-container]',
	txtRelatedTitle    : '.related-title',
};

const SupportResponseSnippet = Snippet.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: function () {
		let classes = 'snippet';
		
		// add special classes if the model has a status set.
		if ( this.model.get( 'status' ) ) {
			classes += ' status-' + this.model.get( 'status' ).toLowerCase();
		}
		
		return classes;
	},
	
	ui: {
		relatedTitle: selectors.txtRelatedTitle,
		open        : selectors.buttonOpen,
		toggle      : selectors.buttonExpand,
		spoiler     : selectors.spoilerExpand,
	},
	
	regions: {
		functionality: selectors.regionFunctionality,
		container    : selectors.regionContainer,
	},
	
	events: {
		'click @ui.open'  : 'onClickOpen',
		'click @ui.toggle': 'onClickToggle',
	},
	
	templateContext: function () {
		
		let superContext = Snippet.prototype.templateContext.call( this );
		
		return _.extend( superContext, {
			canExpand: this.canExpand(),
			header   : this.model.get( 'title' ),
			iconClass: this.getIconClasses(),
		} );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers before the view is shown.
	 * @void
	 */
	onRender: function () {
		this.showFunctionalityView();
		this.showRelatedViews();
	},
	
	/**
	 * Triggers when the user clicks the toggle-button.
	 * @param {event}  The click event.
	 * @overwrite
	 * @void
	 */
	onClickToggle: function ( event ) {
		event.preventDefault();
		
		if ( Mn.getClosestCid( event.target ) !== this.cid ) {
			return;
		}
		
		let $target = $( event.target ).closest( '[data-cid*="view"]' );
		
		this.expandElement( $target );
	},
	
	// event handlers
	
	/**
	 * Triggers when the end user clicks open in this view.
	 * @param {event} event  The click event.
	 * @void
	 */
	onClickOpen: function ( event ) {
		event.preventDefault();
		
		if ( Mn.getClosestCid( event.target ) !== this.cid ) {
			return;
		}
		
		// if it can expand, but hasn't, expand it.
		let $wrapper = $( event.target ).closest( '[data-cid*="view"]' );
		if ( this.canExpand() && !$wrapper.hasClass( 'open' ) ) {
			this.expandElement( $wrapper );
			this.expandOpen();
		}
		
		this.trigger( 'open', this );
	},
	
	
	// child view handlers
	
	/**
	 * Triggers whenever a child view initializes a "installed" event.
	 * @param {view} childView  The view where the event originated from.
	 * @void
	 */
	onChildviewInstalled: function( childView ) {
	 this.trigger( 'installed', childView );
	 },
	
	/**
	 * Triggers whenever a child view initializes a "installed" event.
	 * @param {view} childView  The view where the event originated from.
	 * @void
	 */
	onChildviewLog: function( childView ) {
	 this.trigger( 'log', childView );
	 },
	
	/**
	 * Triggers when the end user clicks "open" in any of the child views.
	 * @param {view} childView  The view where the event originated from.
	 * @void
	 */
	onChildviewOpen: function ( childView ) {
		this.trigger( 'open', childView );
	},
	
	/**
	 * Triggers when a child view requests a migrate.
	 * @param {view} childView  The view where the event originated from.
	 * @void
	 */
	onChildviewMigrate: function( childView ) {
	 this.trigger( 'migrate', childView );
	 },
	
	/**
	 * Triggers whenever a child view initializes a "resize" event.
	 * @void
	 */
	onChildviewResize: function () {
		this.trigger( 'resize' );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Expands the element if it can expand.
	 * @param {jQuery-object} $target  The target to expand from.
	 * @void
	 */
	expandElement: function ( $target ) {
		
		$target.toggleClass( 'open' );
		
		// let the renderer complete before triggering the event.
		let self = this;
		setTimeout( function () {
			self.trigger( 'resize' );
		}, 200 );
		
	},
	
	/**
	 * Checks if this snippet can expand.
	 * @return {bool} True if this snippet is expandable, false if not.
	 */
	canExpand: function () {
		
		let ret = false;
		
		if ( this.model.get( 'related' ).length > 0 ) {
			ret = true;
		}
		
		// classes has buttons.. like: log, migrate, etc...
		let classes = [ 'USER', 'UNIT', 'CUSTOMER', 'INSTALLER', ];
		if ( _.contains( classes, this.model.get( 'class' ) ) ) {
			ret = true;
		}
		
		return ret;
	},
	
	/**
	 * Displays the functionality-view for this support snippet.
	 * @void
	 */
	showFunctionalityView: function () {
		
		let supportResponseFunctionalityView = new SupportResponseFunctionalityView( {
			model: this.model,
		} );
		
		this.showChildView( 'functionality', supportResponseFunctionalityView );
		
	},
	
	/**
	 * Displays the related views for this support snippet.
	 * @void
	 */
	showRelatedViews: function () {
		
		let related = this.model.get( 'related' );
		
		if ( related.length > 0 ) {
			
			this.ui.relatedTitle.removeAttr( 'hidden' );
			
			let supportResponseCollectionView = new SupportResponseCollectionView( {
				collection: related,
			} );
			
			this.showChildView( 'container', supportResponseCollectionView );
		}
	},
	
	/**
	 * Gets the icon-class for this support snippet by model class.
	 * @void
	 */
	getIconClasses: function () {
		
		let iconClass = 'icon icon-labelled ';
		
		switch ( this.model.get( 'class' ) ) {
			
			case 'CUSTOMER'  :
			case 'INSTALLER' :
				iconClass += 'icon-material icon-' + this.model.get( 'type' ).toLowerCase();
				break;
			
			case 'UNIT' :
				iconClass += 'icon-svg icon-' + this.model.get( 'family' ).toLowerCase();
				break;
			
			default:
				iconClass += 'icon-material icon-' + this.model.get( 'class' ).toLowerCase();
				break;
			
		}
		
		return iconClass;
		
	}
	
} );

export default SupportResponseSnippet;